import React from 'react';
import { WorkplaceHealthPlansQuery } from '../../../../graphql/graphql';
// @ts-ignore
import styles from './WorkplaceHealthPlans.module.scss';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import WorkplaceHealthPlan from '../WorkplaceHealthPlan/WorkplaceHealthPlan';

interface Props {
	openCaseTypes: (healthPlanCode: HealthPlanCode) => void;
	data: WorkplaceHealthPlansQuery;
	onUpdate: () => Promise<void>;
}

const WorkplaceHealthPlans: React.FC<Props> = ({
	openCaseTypes,
	data,
	onUpdate,
}) => {
	return (
		<div className={styles.wrapper}>
			{data?.workplaceHealthPlans?.data?.map(item => (
				<WorkplaceHealthPlan
					key={item.id}
					item={item}
					openCaseTypes={openCaseTypes}
					onUpdate={onUpdate}
				/>
			))}
		</div>
	);
};

export default WorkplaceHealthPlans;
